<template>
    <v-container>
      <v-card outlined :loading="load" class="ma-2 px-2">
        <v-card-title>
          Voucher
        </v-card-title>
      <v-row>
        <v-col cols="11" sm="11">
          <!-- Select para o tipo de habilitação -->
          <v-select
            outlined
            v-model="tipoHabilitacao"
            :items="tiposHabilitacao"
            label="Tipo de Habilitação"
            item-text="text"
            item-value="value"
            :loading="loadAtualizarVoucher"
          ></v-select>
        </v-col>
        <v-col cols="1" sm="1">
          <v-btn icon class="mt-2" @click="atualizarVoucher()">
            <v-icon large color="blue">save</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-alert
        v-show="msgAtualizarVoucher"
        dense
        text
        type="success"
      >
        {{ msgAtualizarVoucher }}
      </v-alert>
      <v-row>
        <v-col cols="12" sm="12">
          <!-- Lista de atendentes, desabilitada ou não dependendo do tipo de habilitação -->
          <v-select
            v-model="atendenteSelecionado"
            :items="atendentes"
            label="Selecione o atendente"
            :disabled="!isAtendenteEnabled"
          ></v-select>
        </v-col>
      </v-row>
    </v-card>
    </v-container>
  </template>

<script>

import administradorUnidadeService from '../../services/administradorUnidade.service'

export default {
  data () {
    return {
      user: '',
      loadAtualizarVoucher: false,
      voucherHabilitado: false,
      msgAtualizarVoucher: '',
      tipoHabilitacao: '',
      load: false,
      atendenteSelecionado: '',
      tiposHabilitacao: [
        { text: 'POSAUTOMATICO', value: 'POSAUTOMATICO' },
        { text: 'POSMANUAL', value: 'POSMANUAL' },
        { text: 'SEMPOS', value: 'SEMPOS' }
      ],
      atendentes: [
        { text: 'Atendente 1', value: '1' },
        { text: 'Atendente 2', value: '2' },
        { text: 'Atendente 3', value: '3' }
      ]
    }
  },
  methods: {
    retornarVoucher () {
      this.load = true
      administradorUnidadeService.administradorUnidade.retornarVoucher().then(r => {
        if (r.status == 200) {
          this.tipoHabilitacao = r.data.voucher
        }
      }).finally(() => {
        this.load = false
      })
    },
    atualizarVoucher () {
      this.loadAtualizarVoucher = true
      administradorUnidadeService.administradorUnidade
        .atualizarVoucher(this.tipoHabilitacao).then(r => {
          if (r.status == 200) {
            this.msgAtualizarVoucher = r.data.message
            setTimeout(() => {
              this.msgAtualizarVoucher = ''
            }, 3000)
          }
        }).finally(() => {
          this.loadAtualizarVoucher = false
        })
    }
  },
  computed: {
    // Computed para verificar se a lista de atendentes deve estar habilitada
    isAtendenteEnabled () {
      return this.tipoHabilitacao === 'POSMANUAL'
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.retornarVoucher()
  }
}
</script>

  <style scoped>
  /* Estilos adicionais podem ser colocados aqui, caso necessário */
  </style>
